import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { Path, G } from "react-native-svg"

const SvgIvehteLogo = (props) => {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={25} height={49} fill="none" viewBox="0 0 25 49" {...props}>
            <Path
                fill={baseColors.green.primary}
                d="M23.73 38.209c-1.271-7.675-3.976-10.01-11.78-10.01-7.79 0-10.494 2.319-11.781 10.01-.88 5.355 6.143 8.262 9.906 9.486a.944.944 0 001.239-.98l-.18-2.122a.91.91 0 00-.407-.702c-2.265-1.6-6.387-4.409-6.387-7.087a4.19 4.19 0 014.187-4.196 4.141 4.141 0 012.852 1.11c.39.36.945.36 1.32 0 .765-.702 1.792-1.126 2.851-1.11 2.297.016 4.188 1.894 4.188 4.196 0 2.76-3.878 5.487-6.176 7.087a.993.993 0 00-.407.735l-.212 2.106c-.065.686.733 1.274 1.385 1.061 3.829-1.306 10.281-4.327 9.401-9.584z"
            />
            <Path
                stroke="#fff"
                strokeMiterlimit={10}
                strokeWidth={0.326}
                d="M15.191 15.006a5.182 5.182 0 00-3.372 4.866A5.18 5.18 0 0017 25.064a5.18 5.18 0 005.181-5.192 5.18 5.18 0 00-6.99-4.866z"
            />
            <Path
                stroke={baseColors.green.primary}
                strokeMiterlimit={10}
                strokeWidth={1.169}
                d="M17.017 24.411a4.56 4.56 0 004.562-4.572 4.56 4.56 0 00-4.562-4.572 4.56 4.56 0 00-4.563 4.572 4.57 4.57 0 004.563 4.572z"
            />
            <Path
                fill={baseColors.green.primary}
                d="M11.933 8.67a4.257 4.257 0 004.253-4.262A4.257 4.257 0 0011.933.147 4.257 4.257 0 007.68 4.408a4.257 4.257 0 004.253 4.262z"
            />
            <Path
                fill={baseColors.green.primary}
                stroke="#fff"
                strokeMiterlimit={10}
                strokeWidth={0.326}
                d="M12.96 6.727a10.545 10.545 0 00-1.026-.049c-.212 0-.424 0-.636.017-5.475.326-9.841 4.784-10.037 10.303v.375c0 1.388.26 2.711.733 3.92-.065-.49-.114-.98-.114-1.487 0-.963.326-1.665.587-2.547 4.106-.016 7.479-2.563 9.271-5.976 1.385 4.343 5.898 7.495 10.672 7.511.033.343.05.718.05 1.078 0 .506-.213 1.175-.294 1.665.31-.8.244-1.877.358-2.76.066-.456.082-.914.082-1.387.016-5.568-4.22-10.14-9.646-10.663z"
            />
            <G strokeMiterlimit={10}>
                <Path
                    stroke="#fff"
                    strokeWidth={0.326}
                    d="M9.13 15.202a5.18 5.18 0 00-7.479 4.654 5.3 5.3 0 00.229 1.534"
                />
                <Path
                    fill="#fff"
                    stroke={baseColors.green.primary}
                    strokeWidth={1.169}
                    d="M6.866 24.411a4.56 4.56 0 004.562-4.572 4.56 4.56 0 00-4.562-4.572 4.56 4.56 0 00-4.562 4.572 4.56 4.56 0 004.562 4.572z"
                />
            </G>
            <Path
                stroke={baseColors.green.primary}
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={0.835}
                d="M5.416 19.84s.96-1.52 1.938 0m8.686 0s.96-1.52 1.938 0"
            />
        </Svg>
    )
}

export default SvgIvehteLogo
